export default [
    {
        key: 'internal_management_type.name',
        sortable: true,
        label: 'Tipo de Gestión',
    },
    {
        key: 'client.name',
        sortable: true,
        label: 'Cliente',
    },
    {
        key: 'user.name',
        sortable: true,
        label: 'Usuario que Registra',
    },
    {
        key: 'name',
        sortable: true,
        label: 'Titulo',
    },
    {
        key: 'description',
        sortable: false,
        label: 'Descripción',
    },
    {
        key: 'management_date',
        sortable: true,
        label: 'Fecha Gestión',
    },
    {
        key: 'created_at',
        sortable: true,
        label: 'Fecha Creación',
    },
    {
        key: 'photos',
        sortable: false,
        label: 'Fotos y docs',
    },
    {
        key: 'actions',
        label: 'Acciones',
    },
]
